module.exports = __webpack_public_path__ + "img/hero-performance.eb80e5e2.jpg";